import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { startSyncFacturas } from '@/redux/actions/facturasService';
import { useParams } from '@reach/router';
import SyncIcon from '@mui/icons-material/Sync';
import { LoadingButton } from '@mui/lab';

export const FacturasSyncNemonButton = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const PkVentas = params?.PkVentas;

  const [loading, setLoading] = useState<boolean>(false);

  const handleSyncNemon = () => {
    setLoading(true);
    dispatch(startSyncFacturas(PkVentas, () => setLoading(false)));
  };

  return (
    <LoadingButton
      style={{
        marginRight: '20px',
        backgroundColor: '#F39868',
        color: '#fff',
        borderRadius: 7,
        marginLeft: 10,
      }}
      startIcon={<SyncIcon />}
      onClick={e => {
        e.stopPropagation();
        handleSyncNemon();
      }}
      loading={loading}>
      <Typography style={{ fontWeight: 'bold' }}>Sincronizar con Nemon</Typography>
    </LoadingButton>
  );
};
